import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates a Norwegian fødselsnummer (F-nummer) or D-nummer.
 *
 * Rules enforced:
 *   - Exactly 11 digits (whitespace and hyphens are stripped before checking).
 *
 * The validator returns:
 *   - null when the field is empty (let a separate "required" rule handle that)
 *   - { ninFormat: true }  when the digit count is wrong
 *
 * Server-side validation is still authoritative; this is a client UX hint.
 */
export const nationalIdentityNumberValidator: ValidatorFn =
  (control: AbstractControl): ValidationErrors | null => {
    const raw = (control.value ?? '').toString();
    const value = raw.replace(/[\s-]/g, '');

    if (value.length === 0) return null;
    return /^\d{11}$/.test(value) ? null : { ninFormat: true };
  };
